module.exports = __webpack_public_path__ + "static/img/doctor.1c5d746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doctor.jpg
// module id = fWTm
// module chunks = 8